export enum ProductRevFileNotReadFromFile {
    SCAL360 = 14,
    SmartCal360 = 11,
    LZ50 = 15
  }
  
  


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/interfaces/ProductRevFileNotReadFromFile.model.ts